import React, { useCallback } from "react"
import { Option } from "fp-ts/Option"
import { Trans } from "@lingui/macro"
import { Button, FareCardHeader, FareCardRefundability } from "@silversea-ssc/ui-components-react"
import { FareCode } from "@silversea-ssc/web-fares"
import useModal from "../../../../../components/ModalProvider/useModal"
import { CruisePaymentTermsResponse } from "../../../../_common/dot-com-api-types"
import { FareContent } from "../../../../_common/sanity/sanity-types"
import { depositLabel } from "../../../_common/refundability"
import styles from "./FarePriceHeader.module.scss"

interface FarePriceHeaderProps {
    fareTitle: string
    paymentTerms: Option<CruisePaymentTermsResponse>
    fareCode: FareCode
    fareContent: FareContent
}

export const FarePriceHeader: React.FC<React.PropsWithChildren<FarePriceHeaderProps>> = ({
    paymentTerms,
    fareContent,
    fareCode,
}) => {
    const { openModal } = useModal()

    const onCancellationPolicyClick = useCallback(() => {
        openModal({ modalType: "penalties", selectedFareCode: fareCode })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal, fareCode, JSON.stringify(paymentTerms)])

    const { content: refundabilityContent, isRefundable } = depositLabel(paymentTerms)

    return (
        <FareCardHeader
            title={fareContent.title}
            subtitle={fareContent.headline}
            backgroundColor={"white"}
            variant={"horizontal"}
        >
            {refundabilityContent && (
                <div className={styles.refundabilityContent}>
                    {refundabilityContent && (
                        <FareCardRefundability isRefundable={isRefundable} content={refundabilityContent} />
                    )}
                    <Button
                        renderAs="button"
                        variant="inline-text"
                        onClick={onCancellationPolicyClick}
                        dataContentPiece="read_our_cancellation_policy"
                        noWrap
                    >
                        <Trans>Cancellation Policy</Trans>
                    </Button>
                </div>
            )}
        </FareCardHeader>
    )
}
